<template>
    <div>
        <div class="w-full border bg-white">
            <div class="flex px-2 w-full md:w-10/12 lg:w-8/12 m-auto">

                <div class="flex-1 flex">
                    <router-link :to="{path:'/'}" class="pr-3 " >
                        <img src="~@/assets/logo.png" class="mt-1 w-24" alt="NowRSS">
                    </router-link>
                    
                    <router-link  v-if="user&& user.email" :to="{path:'/'}" class="py-2 px-1 md:px-2 text-gray-500 hover:border-gray-500 border-transparent border-b-2">
                        Home
                    </router-link>
                    
                    <router-link  v-if="user&& user.email" :to="{path:'/ContactUs'}" class="py-2 px-1 md:px-2 text-gray-500 hover:border-gray-500 border-transparent border-b-2">
                        Contact Us
                    </router-link>
                </div>
                
                <div>
                    <div class=" flex" v-if="user&& user.email">
                        <a v-if="!user.premiumPlan" 
                            @click.prevent="$refs.upgradePopupRef.open({})" 
                            class="bg-blue-700 d-inline-block p-1 px-2 mx-2 my-1 rounded cursor-pointer text-white" >
                            Upgrade
                        </a>

                        <div class="float-end dropdown" >
                            
                        
                        <div class="m-1">
                            <img src="~@/assets/man.png" class="dropbtn w-8" alt="user"> 
                        </div>
                        <ul class="dropdown-content rounded">
                            <li v-if="user.email" class="dropdown-item">{{ user.email }}</li>
                            <li v-if="user.email" class="dropdown-item" @click.prevent="$refs.upgradePopupRef.open({})"> {{showPlan(user)}} </li>
                            <li class="dropdown-item" @click.prevent="$refs.logOutRef.open({})">Logout</li>
                        </ul>
                    </div>
                </div>


                    <div class="float-end" v-else>

                        <button :to="{path:'/login'}"
                        @click.prevent="$refs.loginPopupRef.open({tab:$store.state.ACCOUNT_TABS_LOGIN})" 
                        class="float-end text-sm rounded m-1 
                        px-2 py-1.5 border"> Loign </button>

                        <button :to="{path:'/signup'}" 
                        @click.prevent="$refs.loginPopupRef.open({tab:$store.state.ACCOUNT_TABS_SIGNUP})" 
                        class="bg-blue-600	text-white 
                        float-end text-sm rounded m-1  px-2 py-1.5 border"> Sginup </button>
                    </div>

                    <LogInPopUp ref="loginPopupRef" :forceUpdate="forceUpdate"/>
                    <UpgradePopup ref="upgradePopupRef" :confirmedFun="()=>{}" />

                </div>
            </div>
        </div>
        
        <div class="w-full"  
        v-if=" user && user.email && !user.premiumPlan">
            <!-- mesage for user 7 days or older  -->
            <div v-if="daysOldUser(7, user.createdAt)"  style="background-color: #fc0303;"
            class="w-full cursor-pointer text-white text-center" @click.prevent="$refs.upgradePopupRef.open({})">
                <h1 class="m-auto w-full md:w-10/12 lg:w-7/12 px-2 py-2 text-base font-medium">
                    Your trial has expired. Click here to upgrade your subscription ..  
                    <span class="bg-white rounded m-1 py-1 px-2" style="color:rgb(255, 124, 51);">Upgrade Now!</span>
                </h1>
            </div>
            <!-- mesage for user 4 days or older  -->
            <div v-else-if="daysOldUser(4,user.createdAt)" style="background-color: rgb(255, 124, 51);"
            class="w-full cursor-pointer text-white text-center" @click.prevent="$refs.upgradePopupRef.open({})">
                <h1 class="m-auto w-full md:w-10/12 lg:w-7/12 px-2 py-2 text-base font-medium">
                    Your Free Trial Is Ending Soon ..  
                    <span class="bg-white rounded m-1 py-1 px-2" style="color:rgb(255, 124, 51);">Upgrade Now!</span>
                </h1>
            </div>
            <!-- mesage for user 24 h  -->
            <div v-else-if="!daysOldUser(1,user.createdAt)" style="background-color: #4257f5;"
            class="w-full cursor-pointer text-white text-center" @click.prevent="$refs.upgradePopupRef.open({})">
                <h1 class="m-auto w-full md:w-10/12 lg:w-7/12 px-2 py-1 text-base font-medium">
                    Get 27% off yearly subscription – This offer ends in<span class="w-10 inline-block pl-1"> {{ timeLeftVal }} </span>
                </h1>
            </div>

        </div>
        <PopupMessage ref="logOutRef" :confirmedFun="logout" :title="'Please Confirm'" :text="'Sure you want to logout?'" />

    </div>
</template>
  
<script>
import LogInPopUp from '@/components/LogInPopUp'
import PopupMessage from '@/components/PopupMessage'
import UpgradePopup from '@/components/UpgradePopUp'
import User from '@/services/User.service';
import moment from 'moment'

export default {
    name: 'Navbar',
    components: {
        LogInPopUp,
        UpgradePopup,
        PopupMessage
    },
    beforeDestroy() {
        if(this.timer){ clearInterval(this.timer)}
    },
    async mounted(){
        this.$store.state.user = this.user = User.loadUser();
        this.$store.state.user._24H = !this.daysOldUser(1,this.user.createdAt);
        this.$store.state.loginPopupRef = this.$refs.loginPopupRef;
        
        if( this.user && this.user.email && !this.user.premiumPlan && !this.daysOldUser(1,this.user.createdAt)){
            this.timer = setInterval(() => {
                this.timeLeft(this.user.createdAt)
            }, 1000)
        }
    },
    data () {
        return {
            user:{},
            timeLeftVal:'',
            timer:null
        }
    }, 
    methods: {
        logout(){

            User.logout();
            this.forceUpdate();

        },
        forceUpdate(){
            this.$store.state.user = this.user = User.loadUser();
            this.$forceUpdate();
            this.$router.push({path:'/'})
            this.$router.go(0);
        },
        showPlan(user){
            if(user.plan){
                return user.plan + ' Subscription'
            }else{
                const daysLeftOrExpired = this.daysOldUser(7, user.createdAt) ? "Expired" : ((this.daysLeft(7, user.createdAt) + ' Days left'));
                return 'Free Trial (' + daysLeftOrExpired +')'
            }
        },
        daysOldUser(days,date){
            return moment(date).add(days, 'days').isBefore()
        },
        timeLeft(date){
            this.timeLeftVal = moment.utc(moment(date).diff(moment())).format("H:mm:ss")
        },
        daysLeft(days,date){
            return  moment.utc( moment(date).add((days), 'days').diff(moment())).format("D")
        }
    }
}
</script>
 
<style>
 .dropdown {
        position: relative;
        display: inline-block;
        width: 50px;
    }
    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        min-width: 130px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        z-index: 1;
        list-style-type: none;
        margin: 0;
        padding: 0;
        right: 0px;
    }
    

    .dropdown-item{
        padding: 10px;
        cursor: pointer;
    }

    .dropdown-item:hover{
        background-color: rgb(241, 245, 249, 1);
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }
</style>
  


// WEBPACK FOOTER //
// src/components/Navbar.vue